webpackJsonp([142629428675168],{

/***/ 477:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Say Something"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"葉寶史，者主實 12…","frontmatter":{"path":"/hihi/","date":"08 November, 2017","title":"標題 123 ABC"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-d72c732fcb16a38aec9c.js